import { CircularProgress } from '@chakra-ui/react'
import React from 'react'
import { Size } from '~/types/ThemeTypes'

import {
  LoadingSpinnerStyleProperties,
  useLoadingSpinnerStyle,
} from './componentStyles/LoadingSpinner.style'

interface LoadingSpinnerProps {
  size?: Size.sm | Size.md | Size.lg
}
export const LoadingSpinner = ({ size }: LoadingSpinnerProps) => {
  const style = useLoadingSpinnerStyle({ size })
  return (
    <CircularProgress
      isIndeterminate
      color={style[LoadingSpinnerStyleProperties.color]?.toString()}
      trackColor={style[LoadingSpinnerStyleProperties.trackColor]}
      size={style[LoadingSpinnerStyleProperties.size]}
    />
  )
}
